import { useQueryBanks } from '../../../services/api/banksService';

export const useBankAccountsData = (companyId, selectedStatement) => {
  const { data: bankAccounts = [], isLoading: isLoadingBanks } = useQueryBanks(companyId, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  // Processar contas bancárias
  let bankAccountsData = null;
  try {
    bankAccountsData = bankAccounts?.data;
    if (
      bankAccountsData &&
      typeof bankAccountsData === 'object' &&
      !Array.isArray(bankAccountsData)
    ) {
      bankAccountsData = bankAccountsData.data || [];
    }
  } catch (error) {
    console.error('Error processing bank accounts data:', error);
    bankAccountsData = [];
  }

  const bankAccountsArray = Array.isArray(bankAccountsData) ? bankAccountsData : [];

  // Filtrar contas bancárias para remover a conta do extrato atual
  const availableBankAccounts = bankAccountsArray.filter(
    (account) => account && account.id !== selectedStatement?.bankAccountId
  );

  return {
    bankAccounts: bankAccountsArray,
    availableBankAccounts,
    isLoadingBanks,
  };
};
